/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceDto } from '../../models/device-dto';
import { DeviceUpdateReportDto } from '../../models/device-update-report-dto';

export interface DeviceControllerReportUpdateStatus$Params {
  deviceId: string;
      body: DeviceUpdateReportDto
}

export function deviceControllerReportUpdateStatus(http: HttpClient, rootUrl: string, params: DeviceControllerReportUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceDto>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerReportUpdateStatus.PATH, 'post');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceDto>;
    })
  );
}

deviceControllerReportUpdateStatus.PATH = '/api/device/{deviceId}/update-report';
